<template>
    <div>
        <legend>ショップメモ</legend>
        <div class="container-fluid" >
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item" v-for="v in shop_menus" :key="'shop-menu-' + v.id">
                    <button type="button" class="nav-link" :class="{ active: params.menu_id == v.id }" @click="change_menu(v.id)">
                        {{ v.menu_name }}
                    </button>
                </li>
            </ul>

            <div class="row pt-2">
                <div v-for="(v, i) in shop_memos"
                    v-bind:class="{ deleted: v.deleted_at }" class="col-md-3 my-1" style="display: inline-block;" :key="i">
                    <div class="card h-100 border-secondary hover">
                        <div class="head-hover border-bottom bg-secondary text-white ps-2 py-1" style="color:white;"
                            v-clipboard="v.body"
                            @click="onCopy(v.title)">
                            {{v.title}}
                            <i class="fas fa-copy"></i>
                        </div>
                        <div class="card-body flex-wrap overflow-auto p-2">
                            <p>{{v.body}}</p>
                        </div>
                        <div class="card-footer p-2" v-if="v.footer">
                            <div class="border-light">{{v.footer}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
     .card-footer{
        font-size: 0.8rem;
    }
    .card-body {
        font-size: 1rem;
    }

    ::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

</style>

<script>
    import { defineComponent, ref } from 'vue'
    import { toClipboard } from '@soerenmartius/vue3-clipboard'
    import routing from 'mixins/routing';
    export default defineComponent ({
        setup() {
            const value = ref('lorem')
            return { value, toClipboard }
        },
        mixins: [routing],
        data () {
            return {
                params: {
                    menu_id: this.$route.query.menu_id ? this.$route.query.menu_id : null,
                    page: this.$route.query.page ? this.$route.query.page : 1,
                    is_master: 0,
                },
                isloading: false,
                shop_memos: [],
                shop_menus: [],
                options: {
                    animation: 200
                },
            }
        },
        methods: {
            reload() {
                this.isLoading = true;
                axios.get("/tools/shopMemos/lists", {params: this.params}).then(res => {
                    this.shop_memos = res.data;
                    this.routing();
                }).catch(err => {
                    Alert.err(err.response);
                }).finally(() => this.isLoading = false);
            },
            menu_reload() {
                this.isLoading = true;
                axios.get("/tools/shopMemos/menus", {params: this.params}).then(res => {
                    this.shop_menus= res.data.card_menus;
                    this.params.menu_id = this.shop_menus[0]["id"];
                    this.routing();
                }).catch(err => {
                    Alert.err(err.response);
                }).finally(() => this.isLoading = false);
            },
            change_menu(menu_id) {
                this.params.menu_id = menu_id;
                this.routing();
            },
            onCopy(title) {
                Alert.msg("【" + title + "】をコピーしました");
            },
        },
        mounted() {
            this.menu_reload();
            this.reload();
        },
    })
</script>